// src/Dashboard/pages/user/Absences/components/AbsenceAdherentCard.jsx

import React from "react";
import { FaCalendarAlt, FaCheckCircle, FaUser } from "react-icons/fa";

import {
  formatDateFR,
  getAdherentAvatar,
  getAbsenceTone,
  isAdherentAbsent,
} from "../utils/absencesUtils";

export default function AbsenceAdherentCard({
  adherent,
  onMarkReturned,
  busy,
}) {
  if (!adherent) {
    return (
      <div className="rounded-[24px] border border-dashed border-slate-300 bg-slate-50 p-5 text-sm text-slate-500 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-400">
        Sélectionnez un adhérent pour afficher sa fiche d’absence.
      </div>
    );
  }

  const status = getAbsenceTone(adherent);
  const canMarkReturned = isAdherentAbsent(adherent);

  return (
    <article className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950">
      <div className="flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
        <div className="flex min-w-0 items-start gap-4 sm:items-center">
          <img
            src={getAdherentAvatar(adherent)}
            alt={`${adherent.prenom} ${adherent.nom}`}
            className="h-16 w-16 shrink-0 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
            onError={(event) => {
              event.currentTarget.src = "/img/user_avatar.jpg";
            }}
          />

          <div className="min-w-0">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="truncate text-lg font-bold text-slate-900 dark:text-white">
                {adherent.prenom} {adherent.nom}
              </h3>

              <span
                className={`inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-bold ring-1 ${status.className}`}
              >
                {status.label}
              </span>
            </div>

            <div className="mt-2 flex flex-wrap gap-3 text-xs text-slate-500 dark:text-slate-400">
              <span className="inline-flex items-center gap-1.5">
                <FaUser />
                Fiche adhérent
              </span>

              {adherent.date_reprise && (
                <span className="inline-flex items-center gap-1.5">
                  <FaCalendarAlt />
                  Reprise prévue : {formatDateFR(adherent.date_reprise)}
                </span>
              )}
            </div>

            {adherent.notes_adherent && (
              <p className="mt-2 line-clamp-2 text-xs leading-5 text-slate-500 dark:text-slate-400">
                {adherent.notes_adherent}
              </p>
            )}
          </div>
        </div>

        <button
          type="button"
          onClick={onMarkReturned}
          disabled={!canMarkReturned || busy}
          className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-4 py-3 text-sm font-bold text-white transition hover:bg-emerald-700 disabled:cursor-not-allowed disabled:bg-slate-400 sm:w-auto"
        >
          <FaCheckCircle />
          {busy ? "Traitement..." : "Marquer comme repris"}
        </button>
      </div>
    </article>
  );
}